import React from 'react';
import { Switch } from 'react-router-dom';
import AuthRoute from './AuthRoute';


import othersCandidates from "../../../pages/others/Candidates";
import othersRequirements from "../../../pages/others/Requirements";
import othersNew from "../../../pages/others/dashboard/New";
import othersSTC from "../../../pages/others/dashboard/Stc";
import othersDocumentColleted from "../../../pages/others/dashboard/DocumentColleted";
import othersFinalInterviewScheduled from "../../../pages/others/dashboard/FinalInterviewScheduled";
import othersFinalInterviewCompleted from "../../../pages/others/dashboard/FinalInterviewCompleted";
import othersInterviewScheduled from "../../../pages/others/dashboard/InterviewScheduled";
import othersScheduleInterview from "../../../pages/others/dashboard/ScheduleInterview";
import othersJoined from "../../../pages/others/dashboard/Joined";
import othersOffered from "../../../pages/others/dashboard/Offered";
import othersOfferedDeclined from "../../../pages/others/dashboard/OfferedDeclined";
import othersSalaryBreakup from "../../../pages/others/dashboard/SalaryBreakup";
import othersYetToJoin from "../../../pages/others/dashboard/YetToJoin";


import RecCoinWidrawPage from "../../Header/RecCoinWidrawPage";
import ClaimCoins from "../../../pages/others/ClaimCoins";
import FreelancerInvoice from "../../../pages/others/FreelancerInvoice";
import RecCoinHistory from "../../../pages/others/RecCoinHistory";
import DisclosureAgreement from "../../../pages/others/DisclosureAgreement";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import ParsedResume from "../../Candidates/ParsedResume";

const FreelancerRoutes = ({ role }) => {
  return (
    <Switch>
      <AuthRoute path="/app/search" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={Search} />
      <AuthRoute path="/app/dashboard" role={role} roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={Dashboard} />
      <AuthRoute path="/app/parsed_resume" role={role} roles={["ADMIN", "RECRUITER", "CLIENTCOORDINATOR", "FREELANCER", "SUBVENDOR"]} component={ParsedResume} />



      <AuthRoute path="/app/non-disclosure-agreement" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={DisclosureAgreement} />
      <AuthRoute path="/app/claim_coins" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={ClaimCoins} />
      <AuthRoute path="/app/freelancer_invoice" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={FreelancerInvoice} />
      <AuthRoute path="/app/bank_details" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={RecCoinWidrawPage} />
      <AuthRoute path="/app/redeem_invoice" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={RecCoinHistory} />
      <AuthRoute path="/app/freelancer_candidates" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersCandidates} />
      <AuthRoute path="/app/freelancer_requirements" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersRequirements} />
      <AuthRoute path="/app/freelancer_candidates_new" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersNew} />
      <AuthRoute path="/app/freelancer_candidates_stc" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersSTC} />
      <AuthRoute path="/app/freelancer_candidates_schedule_interview" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersScheduleInterview} />
      <AuthRoute path="/app/freelancer_candidates_interview_scheduled" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersInterviewScheduled} />
      <AuthRoute path="/app/freelancer_candidates_fis" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersFinalInterviewScheduled} />
      <AuthRoute path="/app/freelancer_candidates_fic" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersFinalInterviewCompleted} />
      <AuthRoute path="/app/freelancer_candidates_document_collected" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersDocumentColleted} />
      <AuthRoute path="/app/freelancer_candidates_salary_breakup_shared" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersSalaryBreakup} />
      <AuthRoute path="/app/freelancer_candidates_offered" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersOffered} />
      <AuthRoute path="/app/freelancer_candidates_joined" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersJoined} />
      <AuthRoute path="/app/freelancer_candidates_offer_declined" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersOfferedDeclined} />
      <AuthRoute path="/app/freelancer_candidates_yet_to_join" role={role} roles={["FREELANCER", "SUBVENDOR"]} component={othersYetToJoin} />
    </Switch>
  );
};

export default FreelancerRoutes;
